module.exports = __webpack_public_path__ + "img/Machines.28a30b19.svg";